import React from "react";
import { motion } from "framer-motion";
import {
  FaAward,
  FaStar,
  FaTrophy,
  FaMedal,
} from "react-icons/fa";

import award1 from "../assets/awards5.jpeg";
import award2 from "../assets/awards..2.jpg";
import award3 from "../assets/awards..1.jpg";
import award4 from "../assets/awards..4.jpg";
import award5 from "../assets/awards..3.jpg";

const awards = [
  "The Best Reader",
  "Academic Excellence Award",
  "Most Disciplined Student Award",
  "Sports Achiever",
  "The Artist of the Year",
];

const gallery = [
  {
    image: award1,
    title: "Celebrating Achievement",
    number: "01",
  },
  {
    image: award2,
    title: "Academic Excellence",
    number: "02",
  },
  {
    image: award3,
    title: "Student Recognition",
    number: "03",
  },
  {
    image: award4,
    title: "Moments of Pride",
    number: "04",
  },
  {
    image: award5,
    title: "Celebrating Excellence",
    number: "05",
  },
];

const Awards = () => {
  return (
    <section className="bg-[#f7f9fc] overflow-hidden">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="relative bg-gradient-to-br from-[#07294d] via-[#0a3459] to-[#0b416f] py-24 overflow-hidden">

        {/* Decorative Circles */}

        <div className="absolute -top-32 -right-32 w-96 h-96 border-[40px] border-[#d4af37]/10 rounded-full"></div>

        <div className="absolute -bottom-40 -left-32 w-[450px] h-[450px] border-[35px] border-white/5 rounded-full"></div>

        <div className="absolute top-20 left-[15%] w-3 h-3 bg-[#d4af37] rounded-full"></div>

        <div className="absolute top-40 right-[20%] w-2 h-2 bg-[#d4af37]/60 rounded-full"></div>

        <div className="relative max-w-6xl mx-auto px-6 text-center">

          <motion.div
            initial={{ opacity: 0, y: 35 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >

            <div className="w-20 h-20 mx-auto mb-7 rounded-3xl bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center">
              <FaTrophy className="text-[#d4af37] text-3xl" />
            </div>

            <p className="uppercase tracking-[5px] text-[#d4af37] font-bold">
              Cambridge International School
            </p>

            <h1 className="text-5xl md:text-6xl font-black text-white mt-6">
              Awards & Recognition
            </h1>

            <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>

            <p className="max-w-2xl mx-auto text-gray-200 text-lg leading-8">
              Celebrating the dedication, talent and achievements of our
              students and recognising their journey towards excellence.
            </p>

          </motion.div>

        </div>
      </section>


      {/* =====================================================
          MAIN CONTENT
      ===================================================== */}

      <section className="max-w-6xl mx-auto px-6 py-20">

        {/* =====================================================
            INTRO
        ===================================================== */}

        <motion.div
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="grid lg:grid-cols-[1fr_0.8fr] gap-12 items-center mb-20"
        >

          {/* LEFT */}

          <div>

            <div className="flex items-center gap-4 mb-6">

              <div className="w-14 h-1 bg-[#d4af37] rounded-full"></div>

              <p className="uppercase tracking-[4px] text-[#d4af37] font-bold text-sm">
                Excellence Matters
              </p>

            </div>

            <h2 className="text-4xl md:text-5xl font-black text-[#07294d] leading-tight mb-7">

              Recognising
              <br />

              <span className="text-[#d4af37]">
                Young Achievers
              </span>

            </h2>

            <p className="text-gray-600 text-lg leading-9">
              The children were awarded under these 5 categories. These
              recognitions celebrate their efforts, dedication, creativity,
              discipline and achievements across different areas of school
              life.
            </p>

          </div>


          {/* RIGHT STATS CARD */}

          <div className="relative">

            <div className="absolute -top-5 -right-5 w-20 h-20 border-[12px] border-[#d4af37]/20 rounded-full"></div>

            <div className="bg-white rounded-[30px] shadow-xl border border-gray-100 p-8">

              <div className="grid grid-cols-2 gap-6">

                <div className="bg-[#f8fbff] rounded-2xl p-6 text-center">

                  <FaAward className="text-[#d4af37] text-3xl mx-auto mb-3" />

                  <h3 className="text-3xl font-black text-[#07294d]">
                    05
                  </h3>

                  <p className="text-gray-500 text-sm mt-1">
                    Award Categories
                  </p>

                </div>


                <div className="bg-[#07294d] rounded-2xl p-6 text-center">

                  <FaMedal className="text-[#d4af37] text-3xl mx-auto mb-3" />

                  <h3 className="text-3xl font-black text-white">
                    05
                  </h3>

                  <p className="text-gray-300 text-sm mt-1">
                    Award Moments
                  </p>

                </div>

              </div>

            </div>

          </div>

        </motion.div>


        {/* =====================================================
            AWARD CATEGORIES
        ===================================================== */}

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="mb-24"
        >

          <div className="text-center mb-12">

            <p className="uppercase tracking-[4px] text-[#d4af37] font-bold text-sm mb-4">
              Our Recognition
            </p>

            <h2 className="text-4xl font-black text-[#07294d]">
              Award Categories
            </h2>

            <div className="w-20 h-1 bg-[#d4af37] rounded-full mx-auto mt-5"></div>

          </div>


          <div className="grid md:grid-cols-2 xl:grid-cols-5 gap-5">

            {awards.map((award, index) => (

              <motion.div
                key={index}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.08,
                }}
                viewport={{ once: true }}
                whileHover={{ y: -8 }}
                className="group bg-white rounded-[24px] p-6 shadow-md hover:shadow-xl border border-gray-100 transition duration-300"
              >

                <div className="flex items-center justify-between mb-6">

                  <div className="w-12 h-12 rounded-2xl bg-[#07294d] text-white flex items-center justify-center group-hover:bg-[#d4af37] transition duration-300">

                    <FaStar />

                  </div>

                  <span className="text-4xl font-black text-gray-100">
                    0{index + 1}
                  </span>

                </div>

                <h3 className="text-lg font-bold text-[#07294d] leading-7">
                  {award}
                </h3>

                <div className="w-10 h-1 bg-[#d4af37] rounded-full mt-5"></div>

              </motion.div>

            ))}

          </div>

        </motion.div>


        {/* =====================================================
            AWARDS GALLERY
        ===================================================== */}

        <div>

          {/* Gallery Heading */}

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="text-center mb-14"
          >

            <p className="uppercase tracking-[5px] text-[#d4af37] font-bold text-sm mb-4">
              Moments Of Pride
            </p>

            <h2 className="text-4xl md:text-5xl font-black text-[#07294d]">
              Awards Gallery
            </h2>

            <div className="w-20 h-1 bg-[#d4af37] rounded-full mx-auto mt-6"></div>

            <p className="max-w-2xl mx-auto text-gray-500 mt-6 leading-8">
              A collection of memorable moments celebrating the achievements
              and accomplishments of our students.
            </p>

          </motion.div>


          {/* =====================================================
              FIRST 4 AWARDS
          ===================================================== */}

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">

            {gallery.slice(0, 4).map((item, index) => (

              <motion.div
                key={index}
                initial={{
                  opacity: 0,
                  y: 40,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.1,
                }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
                className="group cursor-pointer"
                onClick={() => window.open(item.image, "_blank")}
              >

                {/* Image Card */}

                <div className="relative bg-white rounded-[28px] p-3 shadow-xl border border-gray-100">

                  {/* Award Badge */}

                  <div className="absolute top-5 left-5 z-10 w-10 h-10 rounded-full bg-[#d4af37] text-white flex items-center justify-center shadow-lg">

                    <FaAward className="text-sm" />

                  </div>


                  {/* Image */}

                  <div className="relative overflow-hidden rounded-[22px] bg-[#f3f6fa]">

                    <img
                      src={item.image}
                      alt={item.title}
                      className="
                        w-full
                        h-auto
                        max-h-[560px]
                        object-contain
                        block
                        transition
                        duration-700
                        group-hover:scale-[1.03]
                      "
                    />

                  </div>

                </div>


                {/* Information */}

                <div className="pt-5 px-2">

                  <div className="flex items-center gap-3 mb-2">

                    <span className="text-sm font-black text-[#d4af37]">
                      {item.number}
                    </span>

                    <div className="w-8 h-px bg-gray-300"></div>

                  </div>

                  <h3 className="text-xl font-black text-[#07294d]">
                    {item.title}
                  </h3>

                </div>

              </motion.div>

            ))}

          </div>


          {/* =====================================================
              FEATURED 5TH AWARD
          ===================================================== */}

          <motion.div
            initial={{
              opacity: 0,
              y: 50,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              duration: 0.8,
            }}
            viewport={{ once: true }}
            className="mt-14 flex justify-center"
          >

            <motion.div
              whileHover={{ y: -10 }}
              transition={{ duration: 0.3 }}
              className="group cursor-pointer w-full sm:w-[75%] lg:w-[48%]"
              onClick={() => window.open(gallery[4].image, "_blank")}
            >

              {/* Featured Image Card */}

              <div className="relative bg-white rounded-[32px] p-4 shadow-2xl border border-gray-100">

                {/* Featured Badge */}

                <div className="absolute top-7 left-7 z-10 w-12 h-12 rounded-full bg-[#d4af37] text-white flex items-center justify-center shadow-xl">

                  <FaTrophy className="text-lg" />

                </div>


                {/* Featured Label */}

                <div className="absolute top-7 right-7 z-10 bg-[#07294d] text-white px-4 py-2 rounded-full text-xs font-bold tracking-wider shadow-lg">

                  FEATURED

                </div>


                {/* Image */}

                <div className="relative overflow-hidden rounded-[25px] bg-[#f3f6fa]">

                  <img
                    src={gallery[4].image}
                    alt={gallery[4].title}
                    className="
                      w-full
                      h-[480px]
                      sm:h-[520px]
                      object-contain
                      block
                      transition
                      duration-700
                      group-hover:scale-[1.03]
                    "
                  />

                </div>

              </div>


              {/* Featured Information */}

              <div className="text-center pt-6">

                <div className="flex items-center justify-center gap-3 mb-3">

                  <span className="text-sm font-black text-[#d4af37]">
                    05
                  </span>

                  <div className="w-10 h-px bg-gray-300"></div>

                  <span className="uppercase tracking-[3px] text-xs font-bold text-gray-400">
                    Special Recognition
                  </span>

                </div>

                <h3 className="text-2xl md:text-3xl font-black text-[#07294d]">
                  {gallery[4].title}
                </h3>

                <div className="w-14 h-1 bg-[#d4af37] rounded-full mx-auto mt-4"></div>

              </div>

            </motion.div>

          </motion.div>

        </div>


        {/* =====================================================
            BOTTOM MESSAGE
        ===================================================== */}

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="relative overflow-hidden bg-[#07294d] rounded-[35px] p-10 md:p-14 mt-24 text-center"
        >

          <div className="absolute -top-24 -right-24 w-64 h-64 border-[30px] border-[#d4af37]/10 rounded-full"></div>

          <div className="absolute -bottom-32 -left-20 w-72 h-72 border-[25px] border-white/5 rounded-full"></div>


          <div className="relative">

            <FaTrophy className="text-[#d4af37] text-4xl mx-auto mb-6" />

            <h2 className="text-3xl md:text-4xl font-black text-white mb-5">
              Every Achievement Deserves To Be Celebrated
            </h2>

            <p className="max-w-3xl mx-auto text-gray-300 text-lg leading-8">
              At Cambridge International School, we encourage our students
              to pursue excellence, recognise their efforts and celebrate
              every milestone along their journey.
            </p>

          </div>

        </motion.div>

      </section>

    </section>
  );
};

export default Awards;